import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_RecipientRightsResponsibilities = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_RecipientRightsResponsibilities' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'> <center> Recipient's Rights and Responsibilities </center> </p>

                <p className='w-750'>
                    All recipients have the following rights:
                    <ol>
                        <li>
                            The right to privacy, security, and respect of property.
                        </li>
                        <li>
                            The right to voice a complaint or concern regarding care or service.
                        </li>
                        <li>
                            The right to participate in all aspects of care/services and planning of care/services.
                        </li>
                        <li>
                            The right to refuse all or parts of his/her care to extent permitted by law.
                        </li>
                        <li>
                            The right to have resuscitative services withheld and life-sustaining treatment withdrawn.
                        </li>
                        <li>
                            The right to informatin about the cost of services that will be billed to his/her insurance(s) and/or self (verbally and in writing).
                        </li>
                        <li>
                            The right to information about the value or purpose or any technical procedure that will be performed, including the benefits, risks, and who will perform the task/procedure.
                        </li>
                        <li>
                            The right to information about ownership or control of the agency.
                        </li>
                        <li>
                            The right to review records.
                        </li>
                        <li>
                            The right to 24-hour crisis intervention.
                        </li>
                        <li>
                            The right to protection from abuse, neglect, retaliation, humilliation, and exploitation, However, Restore Outreach Center, LLC reserves the right to include emergency intervention and other special treatment interventions when necessary. When emergency intervention or other treatment interventions are used, Restore Outreach Center, LLC assures that they will be administered with consideration given to the physical, developmental, and abuse history of the person served.
                        </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <strong>IMPORTANT:</strong>
                    If at any time a staff member becomes aware of an infringement or violation of a recipient's rights, it is the responsibility of that employee to report that infringement or violation directly to the Clinical Director or the program coordinator as quickly as possible. Futhermore, all such incidents must be documented on a Critical Incident Form immediately.
                </p>
                <p className='w-750'>
                    <strong>All recipients have the following responsibilities, unless otherwise stuited by the agency upon enrollment:</strong>
                </p>
                <p className='w-750'> 
                <ul>
                    <li>
                        The recipient is responsible for attending group meetings in the community and agency.
                    </li>
                    <li>
                        The recipient is responsible for allowing agency staff to enter the recipient's home for home visits. Recipients must make resonable efforts to schedule and meet with agency staff for regular home visits.
                    </li>
                    <li>
                        The recipient is responsible for meeting with psychiatrist once a month or as scheduled.
                    </li>
                    <li>
                        The recipient is responsible for preparing for transportation during group settings and psychiatrist visits.
                    </li>
                    <li>
                        The recipient is responsible for signing the Individualized. Service Recovery Plan at the start of services and every three months thereafter with the Licensed Mental Health Professional (LMHP) and Psychiatrist.
                    </li>
                    <li>
                        The recipient is responsible for obtaining medicine as prescribed by the Psychiatrist.
                    </li>
                    <li>
                        The recipient is responsible for ensuring compliance in taking prescribed medications and reporting side effects on the medications to the Licensed Mental Health Professional/Psychiatrist.
                    </li>
                    <li>
                        The recipient is responsible for calling the Licensed Mental Health Professional if moving (change of address/phone number), hospitalized (for any reason), or leaving the local area for an extended period of time to ensure continuity of care.
                    </li>
                </ul>
                </p>
                <p className='w-750'>
                    <strong>By signing below, I acknowledge that teh staff has explained my Rights and Responsibilities as a client or Restore Outreach Center, LLC.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'> Recipient's Name: </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-550 signature'> &nbsp; </td>
                        <td className='w-250 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'> Recipient's Signature: (Parent/Guardian if recipient is under 18) </td>
                        <td className='small'> Date: </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I certify that I have explained the Rights and Responsibilities of Restore Outreach Center
                </p>
                <table>
                    <tr>
                        <td className='w-550 signature'> &nbsp; </td>
                        <td className='w-200 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'> Authorized Representative: </td>
                        <td className='small'> Date:  </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}